import { Card, CardContent } from "@material-ui/core";
import { KisshtDialog } from "components/custom/KisshtDialog";
import KisshtTable from "components/table/KisshtTable";
import Spin from "components/ui/Spin";
import React, { useEffect, useState } from "react";
import { fetchConfigViewDetails } from "shared/api/configurations";
import { IsEmpty } from "shared/utils";

export default function ViewConfig({ visible, onClose, data }) {
  const [reload] = useState(false);
  const [spinning, setSpinning] = useState(false);
  const [viewData, setViewData] = useState([]);
  const [expandedRowId, setExpandedRowId] = useState(null);

  const ExpandableCell = ({ value, rowId }) => {
    const isExpanded = expandedRowId === rowId;

    if (
      !value ||
      (typeof value === "object" && Object.keys(value).length === 0)
    ) {
      return <span>-</span>;
    }

    const formattedValue =
      typeof value === "string" ? value : JSON.stringify(value, null, 2);

    const isLong =
      formattedValue.length > 60 || formattedValue.split("\n").length > 2;

    const toggleExpanded = (e) => {
      e.stopPropagation();
      setExpandedRowId(isExpanded ? null : rowId);
    };

    const getTruncatedValue = () => {
      if (formattedValue.length > 60) {
        return formattedValue.substring(0, 60);
      }
      const lines = formattedValue.split("\n");
      if (lines.length > 2) {
        return lines.slice(0, 2).join("\n");
      }
      return formattedValue;
    };

    const displayValue =
      isLong && !isExpanded ? getTruncatedValue() : formattedValue;

    return (
      <div>
        <pre className="expandableCellMetaValue">
          {displayValue}
          {isLong && (
            <button onClick={toggleExpanded} className="expandButton">
              ...{isExpanded ? "View less" : "View more"}
            </button>
          )}
        </pre>
      </div>
    );
  };

  const fetchViewDetails = () => {
    setSpinning(true);
    const params = {
      configuration_id: data?.id,
      merchant_reference_number: "MERT461657987871YZ2V",
    };
    fetchConfigViewDetails(params)
      .then((res) => {
        setSpinning(false);
        if (res.success) {
          setViewData(res?.data?.configuration);
        }
        setSpinning(false);
      })
      .catch((error) => {
        setSpinning(false);
      });
  };

  useEffect(() => {
    fetchViewDetails();
  }, [reload]);

  const columns = [
    {
      Header: "Title",
      accessor: "title",
      sortable: false,
      filterable: false,
      headerClassName: "common_medium_tablewidth",
      Cell: () => {
        return <span>{data?.title || "No title found"}</span>;
      },
    },
    {
      Header: "Previous Meta Value",
      accessor: "meta_value",
      sortable: false,
      filterable: false,
      headerClassName: "common_medium_tablewidth",
      Cell: (cell) => {
        return (
          <ExpandableCell
            value={cell.original?.meta_value}
            rowId={cell.original?.id}
          />
        );
      },
    },
    {
      Header: "Updated By",
      accessor: "created_by_name",
      sortable: false,
      filterable: false,
      headerClassName: "common_medium_tablewidth",
      Cell: (cell) => {
        return <IsEmpty value={"created_by_name"} itemKey={cell.original} />;
      },
    },
    {
      Header: "Timestamp",
      accessor: "updated_at",
      sortable: false,
      filterable: false,
      headerClassName: "common_medium_tablewidth",
      Cell: (cell) => {
        return <IsEmpty value={"updated_at"} itemKey={cell.original} />;
      },
    },
  ];

  return (
    <Spin>
      <KisshtDialog
        title={"Configuration History"}
        maxWidth="lg"
        open={visible}
        handleClose={onClose}
      >
        <div>
          <Card>
            <CardContent>
              <KisshtTable
                loading={spinning}
                columns={columns}
                data={viewData}
                showPagination={false}
              />
            </CardContent>
          </Card>
        </div>
      </KisshtDialog>
    </Spin>
  );
}
